import type * as Types from './type'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  stationTypes: [],
} as Types.IInitialState

/**
 * TODO: 废弃的store
 */
export const dictinarySlice = createSlice({
  name: 'dictinary',
  initialState,
  reducers: {
    setStationTypes(state, action: PayloadAction<Types.StationTypes>) {
      const stationTypes = action.payload
      return { ...state, stationTypes }
    },
  },
})
export const { setStationTypes } = dictinarySlice.actions

export default dictinarySlice.reducer
